import { useMemo } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { Modal as ModalLib } from '@ui-kitten/components';
import { CreateResponsiveStyle, DEVICE_SIZES, minSize } from 'rn-responsive-styles';

import { Text } from '../Text';
import { CloseIcon } from '../../assets';
import { colors, spacing } from '../../theme';
import { Toast, toastConfig } from '../Toast';
import { ModalProps } from './types';

export const Modal = ({
	onClose,
	title,
	children,
	actions,
	style,
	headerStyle,
	contentStyle,
	actionsStyle,
	backdropStyle,
	withOwnToast = true,
	...modalProps
}: ModalProps) => {
	const styles = useStyles();
	const titleElement = useMemo(
		() => (typeof title !== 'string' ? title : <Text category="h4">{title}</Text>),
		[title],
	);

	return (
		<ModalLib
			backdropStyle={[styles.backdrop, backdropStyle]}
			onBackdropPress={onClose}
			shouldUseContainer={!withOwnToast}
			{...modalProps}
		>
			<View style={[styles.root, style]}>
				<View style={[styles.header, headerStyle]}>
					{titleElement}

					{onClose && (
						<TouchableOpacity onPress={onClose}>
							<CloseIcon />
						</TouchableOpacity>
					)}
				</View>

				<View style={[styles.children, contentStyle]}>{children}</View>

				{actions && <View style={[styles.actions, actionsStyle]}>{actions}</View>}
			</View>
			{withOwnToast && <Toast config={toastConfig} />}
		</ModalLib>
	);
};

const MARGIN_HORIZONTAL = spacing(2);
const useStyles = CreateResponsiveStyle(
	{
		root: {
			// @ts-expect-error - this is a valid property for web
			width: `calc(100vw - ${MARGIN_HORIZONTAL * 2}px)`,
			// @ts-expect-error - this is a valid property for web
			maxHeight: '80vh',
			borderRadius: spacing(2),
			padding: spacing(2),
			backgroundColor: colors.neutral200,
			flexDirection: 'column',
			justifyContent: 'center',
			alignItems: 'center',
			gap: spacing(3),
			marginVertical: 'auto',
			alignSelf: 'center',
		},
		backdrop: {
			backgroundColor: colors.primarySemiTransparent,
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-expect-error - this is a valid property for web
			position: 'fixed',
		},
		header: {
			width: '100%',
			flexDirection: 'row',
			justifyContent: 'space-between',
		},
		children: {
			width: '100%',
			//@ts-expect-error web ok
			overflow: 'auto',
			flex: 1,
		},
		actions: {
			width: '100%',
			flexDirection: 'column-reverse',
			gap: spacing(2),
		},
	},
	{
		[minSize(DEVICE_SIZES.MD)]: {
			root: {
				width: 736,
			},
		},
		[minSize(DEVICE_SIZES.LG)]: {
			root: {
				width: 800,
				padding: spacing(4),
			},
			actions: {
				flexDirection: 'row-reverse',
			},
		},
		[minSize(DEVICE_SIZES.XL)]: {
			root: {
				padding: spacing(6),
			},
		},
	},
);
